// accessRequestReducer.js
import {
  REQUEST_ACCESS_REQUEST,
  REQUEST_ACCESS_SUCCESS,
  REQUEST_ACCESS_FAILURE,
} from "../actions/accessRequestActionTypes";

const initialState = {
  loading: false,
  error: null,
  success: false,
};

const accessRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_ACCESS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case REQUEST_ACCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: null,
      };

    case REQUEST_ACCESS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    default:
      return state;
  }
};

export default accessRequestReducer;
